import classNames from "classnames";
import { AppSwitch } from "../../../../../../../shared/components/AppSwitch";
import { useTranslation } from "react-i18next";
import { NormalizedStorageObject } from "../../../../../../../services/api/instances/storageApi/types/object_types";
import { ChatbotValue } from "../../../../../../../services/api/instances/botApi/types";
import { TValueForService } from "../../../../../../../services/api/instances/storageApi/types/service_types";
import { useCallback } from "react";
import { getUpdatedChatbotValue } from "../../../../../helpers/getUpdatedChatbotValue";
import styles from "./styles.module.css";

interface Props {
  bot: NormalizedStorageObject<ChatbotValue>;
  saveChatbotValue: (
    value: TValueForService<"ai_agents_telegram_bots">,
  ) => void;
}

export const ChatValidationSwitcher = (props: Props) => {
  const { t } = useTranslation();

  const handleChangeValidation = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (!props.bot?.value) return;
      const updatedValue = getUpdatedChatbotValue(props.bot.value, {
        check_validation: event.target.checked,
      });
      props.saveChatbotValue(updatedValue);
    },
    [props.bot?.id],
  );
  return (
    <div
      className={classNames(
        styles["blacklist-switch-container"],
        styles["switch-container"],
      )}
    >
      <span
        className={classNames(
          styles["blacklist-switch-label"],
          styles["switch-label"],
        )}
      >
        {t("chatbot.list_restriction_toggle")}
      </span>

      <AppSwitch
        className={styles.switch}
        checked={props.bot?.value?.tg_bot_object?.check_validation ?? false}
        onChange={handleChangeValidation}
      />
    </div>
  );
};
